<template>
  <el-form ref="form"
           :model="form"
           :rules="formRules"
           size="medium"
           label-width="140px"
           @submit.native.prevent="onSubmit()">
    <div class="re-el-form__flex">
      <div class="medium">
        <el-form-item label="用户ID列表"
                      prop="userids">
          <el-input v-model="form.userids"
                    type="textarea"
                    :autosize="{ minRows: 2 }"
                    placeholder="多个用户请使用回车"></el-input>
        </el-form-item>
      </div>
    </div>
    <el-form-item>
      <el-button type="primary"
                 native-type="submit">提交表单
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { formRules } from '@views/user-batch-tag/user-batch-tag.rules.js'

export default {
  components: {},
  props: {
    displayName: String,
  },
  data () {
    return {
      loading: false,

      formRules,
      form: {
        tags: [],
        userids: '',
      },
      options: {
        tags: [],
      },
    }
  },
  computed: {},
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {
    request('queryPlatformUserWhitelistData').then(({data}) => {
      this.form.tags = [data.id]
    })
  },
  mounted () {},
  methods: {
    onLoad () {
    },
    onReload () {
      Object.assign(this.$data, this.$options.data())
      this.onLoad()
    },
    setForm (id) {
    },
    remoteTagMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          request.alert('getUserTagName', {query: query}).then(({data}) => {
            this.options.tags = data
            this.loading = false
          })
        }, 500)
      } else {
        this.options.tags = []
      }
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('submit', this.form)
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/platform-user-whitelist/components/UserBatchTagForm.vue